import React, { Component } from 'react';
import PageHeader from '../../components/page-header';
import './style.scss';
import BottomMenu from '../../components/bottom-menu';
import { Search, Inbox, Pets, AccountCircleOutlined } from '@material-ui/icons';

export default class ViewPet extends Component {
    render() {
        return (
            <div className='view-pet'>
                <PageHeader text='Pet Details' history={this.props.history} />
                <div className="pet-details">
                    <div className="pet-information">
                        <div className="avatar" style={{ background: `#ccc url('${this.props.location.state.pet.picture}') no-repeat center`, backgoundSize: 'cover' }} />
                        <div className='name'>{this.props.location.state.pet.name}</div>
                        <div><span>Age: </span>{this.props.location.state.pet.age} yr</div>
                        <div><span>Weight: </span>{this.props.location.state.pet.weight} lbs</div>
                        <div><span>Gender: </span>Female</div>
                        <div><span>Breed: </span>{this.props.location.state.pet.breed}</div>
                        <br />

                        <div>{this.props.location.state.pet.description}</div>
                        <div>Available at</div>
                        <div>Address: {this.props.location.state.pet.available_at}</div>
                    </div>
                </div>
                <BottomMenu menu_items={[
                    { path: '/pet-borrower', link_name: 'Find borrower', icon: <Search /> },
                    { path: '/', link_name: 'Inbox', icon: <Inbox /> },
                    { path: '/grid-view', link_name: 'My pets', icon: <Pets /> },
                    { path: '/pet-owner', link_name: 'Me', icon: <AccountCircleOutlined /> }
                ]} />
            </div>
        );
    }
}
